import { render, staticRenderFns } from "./editPaIndexModel.vue?vue&type=template&id=cada18d2&"
import script from "./editPaIndexModel.vue?vue&type=script&lang=js&"
export * from "./editPaIndexModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports